export default "__VITE_ASSET__DgeqFvCu__"